import { render, staticRenderFns } from "./album-sharePage.vue?vue&type=template&id=035e8ed3&scoped=true"
import script from "./album-sharePage.vue?vue&type=script&lang=js"
export * from "./album-sharePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e8ed3",
  null
  
)

export default component.exports